import { get, omit } from 'lodash';
import createAction from '../../services/create-action';
import { getDefaultSiteLocale, getLocales, } from '../multilingual-locales/selectors';
import { getTPASettingsData } from './tpa-settings-selectors';
const config = {
    apiBaseUrl: '/_api/app-settings-service',
};
export const FETCH_TPA_SETTINGS_REQUEST = 'tpaSettings/FETCH_SETTINGS_REQUEST';
export const FETCH_TPA_SETTINGS_SUCCESS = 'tpaSettings/FETCH_SETTINGS_SUCCESS';
export const FETCH_TPA_SETTINGS_FAILURE = 'tpaSettings/FETCH_SETTINGS_FAILURE';
export const fetchTPASettingsRequest = createAction(FETCH_TPA_SETTINGS_REQUEST);
export const fetchTPASettingsSuccess = createAction(FETCH_TPA_SETTINGS_SUCCESS, (payload) => payload);
export const fetchTPASettingsFailure = createAction(FETCH_TPA_SETTINGS_FAILURE);
export const fetchTPASettings = ({ host = 'NA', state = 'PUBLISHED', language, } = {}) => async (dispatch, getState, { request }) => {
    dispatch(fetchTPASettingsRequest());
    const languageCode = language ||
        (getLocales(getState()) &&
            get(getDefaultSiteLocale(getState()), 'id', null));
    try {
        const response = await request(`/v1/settings/instances?state=${state}&host=${host}${languageCode ? `&languageKey.languageCode=${languageCode}` : ''}`, config);
        const successPayload = Object.assign({ settings: response.settings }, (languageCode && {
            translations: { [languageCode]: response.translations },
        }));
        dispatch(fetchTPASettingsSuccess(successPayload));
        return successPayload;
    }
    catch (error) {
        dispatch(fetchTPASettingsFailure());
        throw error;
    }
};
export const UPDATE_TPA_SETTINGS_REQUEST = 'tpaSettings/UPDATE_SETTINGS_REQUEST';
export const UPDATE_TPA_SETTINGS_SUCCESS = 'tpaSettings/UPDATE_SETTINGS_SUCCESS';
export const UPDATE_TPA_SETTINGS_FAILURE = 'tpaSettings/UPDATE_SETTINGS_FAILURE';
export const updateTPASettingsRequest = createAction(UPDATE_TPA_SETTINGS_REQUEST);
export const updateTPASettingsSuccess = createAction(UPDATE_TPA_SETTINGS_SUCCESS, (payload) => payload);
export const updateTPASettingsFailure = createAction(UPDATE_TPA_SETTINGS_FAILURE);
export const updateTPASettings = ({ settings, language, translations }, { host = 'NA', states = ['PUBLISHED'] } = {}) => async (dispatch, getState, { request }) => {
    dispatch(updateTPASettingsRequest());
    try {
        const response = await request.patch('/v1/settings/instances', Object.assign({ settings: omit(settings || getTPASettingsData(getState()), [
                '_id',
                'communityId',
            ]), // HACK: settings service does not update with empty settings
            host,
            states }, (language && {
            translations: [
                {
                    languageKey: { languageCode: language },
                    translations,
                },
            ],
        })), config);
        dispatch(updateTPASettingsSuccess({
            settings: response.settings,
            // @ts-expect-error
            translations: { [language]: translations },
        }));
    }
    catch (error) {
        dispatch(updateTPASettingsFailure());
    }
};
//# sourceMappingURL=tpa-settings-actions.js.map